import { getContracts } from "./get-contracts"

const contracts = {
  getContracts,
}

export default contracts
